import { render } from "./LoginCallback.vue?vue&type=template&id=07fd88e8"
import script from "./LoginCallback.vue?vue&type=script&lang=js"
export * from "./LoginCallback.vue?vue&type=script&lang=js"
script.render = render

export default script